export default "__VITE_ASSET__389dd4be__"